// import React from "react";
// import { Package, RefreshCw, Headphones, CreditCard } from "lucide-react";
// const newsItems = [
//   {
//     id: 1,
//     image: "/images/news1.webp",
//     description:
//       "Our partnership with ICC for the ground force and umpire clothing has been very rewarding.",
//   },
//   {
//     id: 2,
//     image: "/images/news2.webp",
//     description:
//       "All stars football is the celebrity teams doing it all for the good cause making tyka part of it.",
//   },
//   {
//     id: 3,
//     image: "/images/news3.webp",
//     description:
//       "With Khelo India we are able to get to the parts of the country to spread our wings.",
//   },
// ];

// const LatestNews = () => {
//   return (
//     <>
//       {/* Centered grey line above */}
//       <div className="h-px bg-gray-300 mx-auto mb-4" style={{ width: "67%" }} />
//       <section className="max-w-7xl mx-auto py-12 px-4">
//         {/* Top Feature Boxes (Free Shipping, Guarantee, Support, Payment) */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
//           {/* Feature Item */}
//           <div className="flex items-start space-x-4">
//             <Package className="w-10 h-10 flex-shrink-0" />
//             <div>
//               <h3 className="font-semibold text-base">Free Shipping</h3>
//               <p className="text-sm text-gray-600">
//                 Free Shipping for prepaid orders
//               </p>
//             </div>
//           </div>

//           <div className="flex items-start space-x-4">
//             <RefreshCw className="w-10 h-10 flex-shrink-0" />
//             <div>
//               <h3 className="font-semibold text-base">Easy Exchange</h3>
//               <p className="text-sm text-gray-600">
//                 Hassle-free exchange process for your convenience.
//               </p>
//             </div>
//           </div>

//           <div className="flex items-start space-x-4">
//             <Headphones className="w-10 h-10 flex-shrink-0" />
//             <div>
//               <h3 className="font-semibold text-base">Full Support</h3>
//               <p className="text-sm text-gray-600">
//                 We provide complete support until your product is delivered.
//               </p>
//             </div>
//           </div>

//           <div className="flex items-start space-x-4">
//             <CreditCard className="w-10 h-10 flex-shrink-0" />
//             <div>
//               <h3 className="font-semibold text-base">Flexible Payment</h3>
//               <p className="text-sm text-gray-600">
//                 Pay with Multiple Credit Cards.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>
//       {/* Latest News Section */}
//       <section className="py-16 px-4 text-center -mt-20">
//         <h2 className="text-2xl sm:text-3xl font-semibold mb-4">
//           Our Latest News
//         </h2>
//         <p className="text-gray-600 max-w-4xl mx-auto mb-12">
//           From product innovations and campaigns to the partnerships and big
//           bets that propelled the Brand forward, these are the moments that made
//           us who we are.
//         </p>
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
//           {newsItems.map((item) => (
//             <div key={item.id} className="text-left">
//               <img
//                 src={item.image}
//                 alt={item.title}
//                 className="w-full h-auto mb-4 object-cover"
//               />
//               <h4 className="text-sm font-bold mb-2">{item.description}</h4>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Visit Our Store Section */}
//       <section className="pt-16 pb-40 sm:pb-56 px-4 text-center relative">
//         <div className="max-w-6xl mx-auto relative">
//           {/* Store Image */}
//           <img
//             src="/images/store.jpeg"
//             alt="Visit Our Store"
//             className="w-full h-[565px] object-cover"
//           />

//           {/* Floating Card (desktop) */}
//           <div className="hidden sm:block absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-1/2 bg-white p-6 sm:p-10 max-w-2xl w-[90%]">
//             <h3 className="text-xl sm:text-2xl font-semibold mb-4">
//               Visit Our Store
//             </h3>
//             <p className="text-gray-700 mb-2">
//               Plot No. - 5, Sector 17/18 Dividing Lane, Near IFFCO Chownk,
//               Gurgaon - 122001, Haryana
//             </p>
//             <p className="text-gray-700 mb-2">
//               Email:{" "}
//               <a href="sales.ncr@tyka.com" className="text-blue-600 underline">
//                 sales.ncr@tyka.com
//               </a>
//             </p>
//             <p className="text-gray-700">Phone: +91 95991 55555</p>
//           </div>
//         </div>

//         {/* Static Card (mobile) */}
//         <div className="block sm:hidden mt-6 bg-white -mb-[40%] shadow-lg p-6 max-w-2xl mx-auto w-[90%]">
//           <h3 className="text-xl font-semibold mb-4">Visit Our Store</h3>
//           <p className="text-gray-700 mb-2">
//             TK Sports Pvt. Ltd., 407, Leather Complex, Kapurthala Road,
//             Jalandhar
//           </p>
//           <p className="text-gray-700 mb-2">
//             Email:{" "}
//             <a href="sales.ncr@tyka.com" className="text-blue-600 underline">
//               sales.ncr@tyka.com
//             </a>
//           </p>
//           <p className="text-gray-700">Phone: +91 95991 55555</p>
//         </div>
//       </section>
//     </>
//   );
// };

// export default LatestNews;

// working code without slug

// import React, { useEffect, useState } from "react";
// import { Package, RefreshCw, Headphones, CreditCard } from "lucide-react";
// const LatestNews = () => {
//   const [newsItems, setNewsItems] = useState([]);

//   // Fetch Blogs from API
//   useEffect(() => {
//     const fetchNews = async () => {
//       try {
//         const res = await fetch(
//           "https://tyka.premierhostings.com/backend/api/site-blogs"
//         );
//         const data = await res.json();

//         if (data && Array.isArray(data.data)) {
//           // Filter out blogs without image
//           const filtered = data.data.filter(
//             (item) => item.image && item.image !== ""
//           );
//           setNewsItems(filtered);
//         }
//       } catch (error) {
//         console.error("Error fetching news:", error);
//       }
//     };

//     fetchNews();
//   }, []);
//   return (
//     <>
//       {/* Centered grey line above */}
//       <div className="h-px bg-gray-300 mx-auto mb-4" style={{ width: "67%" }} />
//       <section className="max-w-7xl mx-auto py-12 px-4">
//         {/* Top Feature Boxes (Free Shipping, Guarantee, Support, Payment) */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
//           {/* Feature Item */}
//           <div className="flex items-start space-x-4">
//             <Package className="w-10 h-10 flex-shrink-0" />
//             <div>
//               <h3 className="font-semibold text-base">Free Shipping</h3>
//               <p className="text-sm text-gray-600">
//                 Free Shipping for prepaid orders
//               </p>
//             </div>
//           </div>

//           <div className="flex items-start space-x-4">
//             <RefreshCw className="w-10 h-10 flex-shrink-0" />
//             <div>
//               <h3 className="font-semibold text-base">Easy Exchange</h3>
//               <p className="text-sm text-gray-600">
//                 Hassle-free exchange process for your convenience.
//               </p>
//             </div>
//           </div>

//           <div className="flex items-start space-x-4">
//             <Headphones className="w-10 h-10 flex-shrink-0" />
//             <div>
//               <h3 className="font-semibold text-base">Full Support</h3>
//               <p className="text-sm text-gray-600">
//                 We provide complete support until your product is delivered.
//               </p>
//             </div>
//           </div>

//           <div className="flex items-start space-x-4">
//             <CreditCard className="w-10 h-10 flex-shrink-0" />
//             <div>
//               <h3 className="font-semibold text-base">Flexible Payment</h3>
//               <p className="text-sm text-gray-600">
//                 Pay with Multiple Credit Cards.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>
//       {/* Latest News Section */}
//       <section className="py-16 px-4 text-center -mt-20">
//         <h2 className="text-2xl sm:text-3xl font-semibold mb-4">
//           Our Latest News
//         </h2>
//         <p className="text-gray-600 max-w-4xl mx-auto mb-12">
//           From product innovations and campaigns to the partnerships and big
//           bets that propelled the Brand forward, these are the moments that made
//           us who we are.
//         </p>
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
//           {/* {newsItems.map((item) => (
//             <div key={item.id} className="text-left">
//               <img
//                 src={item.image}
//                 alt={item.title}
//                 className="w-full h-auto mb-4 object-cover"
//               />
//               <h4 className="text-sm font-bold mb-2">{item.description}</h4>
//             </div>
//           ))} */}
//           {newsItems.map((item) => (
//             <div key={item.id} className="text-left">
//               <img
//                 src={`https://tyka.premierhostings.com/backend/storage/${item.image}`}
//                 alt={item.excerpt || "news-image"}
//                 className="w-full h-auto mb-4 object-cover"
//               />
//               <h4 className="text-sm font-bold mb-2">
//                 {item.description || item.excerpt}
//               </h4>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Visit Our Store Section */}
//       <section className="pt-16 pb-40 sm:pb-56 px-4 text-center relative">
//         <div className="max-w-6xl mx-auto relative">
//           {/* Store Image */}
//           <img
//             src="/images/store.jpeg"
//             alt="Visit Our Store"
//             className="w-full h-[565px] object-cover"
//           />

//           {/* Floating Card (desktop) */}
//           <div className="hidden sm:block absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-1/2 bg-white p-6 sm:p-10 max-w-2xl w-[90%]">
//             <h3 className="text-xl sm:text-2xl font-semibold mb-4">
//               Visit Our Store
//             </h3>
//             <p className="text-gray-700 mb-2">
//               Plot No. - 5, Sector 17/18 Dividing Lane, Near IFFCO Chownk,
//               Gurgaon - 122001, Haryana
//             </p>
//             <p className="text-gray-700 mb-2">
//               Email:{" "}
//               <a href="sales.ncr@tyka.com" className="text-blue-600 underline">
//                 sales.ncr@tyka.com
//               </a>
//             </p>
//             <p className="text-gray-700">Phone: +91 95991 55555</p>
//           </div>
//         </div>

//         {/* Static Card (mobile) */}
//         <div className="block sm:hidden mt-6 bg-white -mb-[40%] shadow-lg p-6 max-w-2xl mx-auto w-[90%]">
//           <h3 className="text-xl font-semibold mb-4">Visit Our Store</h3>
//           <p className="text-gray-700 mb-2">
//             TK Sports Pvt. Ltd., 407, Leather Complex, Kapurthala Road,
//             Jalandhar
//           </p>
//           <p className="text-gray-700 mb-2">
//             Email:{" "}
//             <a href="sales.ncr@tyka.com" className="text-blue-600 underline">
//               sales.ncr@tyka.com
//             </a>
//           </p>
//           <p className="text-gray-700">Phone: +91 95991 55555</p>
//         </div>
//       </section>
//     </>
//   );
// };

// export default LatestNews;

import React, { useEffect, useState } from "react";
import { Package, RefreshCw, Headphones, CreditCard } from "lucide-react";
import { Link } from "react-router-dom"; // <-- added

const LatestNews = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [storeImage, setStoreImage] = useState("");

  // Fetch Store Image
  useEffect(() => {
    const fetchStoreImage = async () => {
      try {
        const res = await fetch(
          "https://tyka.premierhostings.com/backend/api/menu"
        );
        const data = await res.json();

        console.log("✅ Menu API response:", data);

        // Access store image directly from settings
        const storeImgUrl = data?.settings?.store_image;

        if (storeImgUrl) {
          console.log("✅ Store image found:", storeImgUrl);
          setStoreImage(storeImgUrl);
        } else {
          console.warn("⚠️ No store_image found in settings");
        }
      } catch (error) {
        console.error("❌ Error fetching store image:", error);
      }
    };

    fetchStoreImage();
  }, []);

  // Fetch Blogs from API
  useEffect(() => {
    let mounted = true;
    const fetchNews = async () => {
      try {
        const res = await fetch(
          "https://tyka.premierhostings.com/backend/api/site-blogs"
        );
        const data = await res.json();

        if (!mounted) return;

        // API might return { data: [...] } or [...], handle both
        const list = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : [];

        if (Array.isArray(list)) {
          // Filter out blogs without image
          const filtered = list.filter(
            (item) => item?.image && item.image !== ""
          );
          setNewsItems(filtered);
        } else {
          setNewsItems([]);
        }
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };

    fetchNews();
    return () => {
      mounted = false;
    };
  }, []);
  return (
    <>
      {/* Centered grey line above */}
      <div className="h-px bg-gray-300 mx-auto mb-4" style={{ width: "67%" }} />
      <section className="max-w-7xl mx-auto py-12 px-4">
        {/* Top Feature Boxes (Free Shipping, Guarantee, Support, Payment) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {/* Feature Item */}
          <div className="flex items-start space-x-4">
            <Package className="w-10 h-10 flex-shrink-0" />
            <div>
              <h3 className="font-semibold text-base">Free Shipping</h3>
              <p className="text-sm text-gray-600">
                Free Shipping for prepaid orders
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <RefreshCw className="w-10 h-10 flex-shrink-0" />
            <div>
              <h3 className="font-semibold text-base">Easy Exchange</h3>
              <p className="text-sm text-gray-600">
                Hassle-free exchange process for your convenience.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <Headphones className="w-10 h-10 flex-shrink-0" />
            <div>
              <h3 className="font-semibold text-base">Full Support</h3>
              <p className="text-sm text-gray-600">
                We provide complete support until your product is delivered.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <CreditCard className="w-10 h-10 flex-shrink-0" />
            <div>
              <h3 className="font-semibold text-base">Flexible Payment</h3>
              <p className="text-sm text-gray-600">
                Pay with Multiple Credit Cards.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Latest News Section */}
      <section className="py-16 px-4 text-center -mt-20">
        <h2 className="text-2xl sm:text-3xl font-semibold mb-4">
          Our Latest News
        </h2>
        <p className="text-gray-600 max-w-4xl mx-auto mb-12">
          From product innovations and campaigns to the partnerships and big
          bets that propelled the Brand forward, these are the moments that made
          us who we are.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {newsItems.map((item) => {
            // prefer slug; fall back to id if slug not present
            const slug =
              item?.slug || item?.slug_name || item?.slug_url || item?.id;
            // image may already be a full URL or only a path; handle both
            const imageUrl =
              item?.image &&
              (item.image.startsWith("http") || item.image.startsWith("//"))
                ? item.image
                : `https://tyka.premierhostings.com/backend/storage/${item?.image}`;

            return (
              <div key={item.id} className="text-left">
                {/* clicking image (anywhere on it) will navigate to /site-blogs/:slug */}
                <Link to={`/blogs/${slug}`} className="block">
                  <img
                    src={imageUrl}
                    alt={item.excerpt || "news-image"}
                    className="w-full h-auto mb-4 object-cover cursor-pointer"
                  />
                </Link>

                <h4 className="text-sm font-bold mb-2">
                  {/* also make title clickable */}
                  <Link to={`/blogs/${slug}`} className="hover:underline">
                    {item.description || item.excerpt || item.title}
                  </Link>
                </h4>
              </div>
            );
          })}
        </div>
      </section>

      {/* Visit Our Store Section */}
      <section className="pt-16 pb-40 sm:pb-56 px-4 text-center relative">
        <div className="max-w-6xl mx-auto relative">
          {/* Store Image */}
          <img
            src={storeImage || "/images/store.webp"}
            alt="Visit Our Store"
            className="w-full h-[565px] object-cover"
          />

          {/* Floating Card (desktop) */}
          <div className="hidden sm:block absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-1/2 bg-white p-6 sm:p-10 max-w-2xl w-[90%]">
            <h3 className="text-xl sm:text-2xl font-semibold mb-4">
              Visit Our Store
            </h3>
            <p className="text-gray-700 mb-2">
              Plot No. - 5, Sector 17/18 Dividing Lane, Near IFFCO Chownk,
              Gurgaon - 122001, Haryana
            </p>
            <p className="text-gray-700 mb-2">
              Email:{" "}
              <a href="sales.ncr@tyka.com" className="text-blue-600 underline">
                sales.ncr@tyka.com
              </a>
            </p>
            <p className="text-gray-700">Phone: +91 95991 55555</p>
          </div>
        </div>

        {/* Static Card (mobile) */}
        <div className="block sm:hidden mt-6 bg-white -mb-[40%] shadow-lg p-6 max-w-2xl mx-auto w-[90%]">
          <h3 className="text-xl font-semibold mb-4">Visit Our Store</h3>
          <p className="text-gray-700 mb-2">
            TK Sports Pvt. Ltd., 407, Leather Complex, Kapurthala Road,
            Jalandhar
          </p>
          <p className="text-gray-700 mb-2">
            Email:{" "}
            <a href="sales.ncr@tyka.com" className="text-blue-600 underline">
              sales.ncr@tyka.com
            </a>
          </p>
          <p className="text-gray-700">Phone: +91 95991 55555</p>
        </div>
      </section>
    </>
  );
};

export default LatestNews;
